/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_9_QInputs */

const en_pc_faq_9_q = /** @type {(inputs: Pc_Faq_9_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does PhotoCraft have AI features?`)
};

const zh_pc_faq_9_q = /** @type {(inputs: Pc_Faq_9_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft 有 AI 功能吗？`)
};

/**
* | output |
* | --- |
* | "Does PhotoCraft have AI features?" |
*
* @param {Pc_Faq_9_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_9_q = /** @type {((inputs?: Pc_Faq_9_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_9_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_9_q(inputs)
	return zh_pc_faq_9_q(inputs)
});
export { pc_faq_9_q as "pc.faq.9.q" }